import i18n from "../i18n";

interface IUsedCookie {
    cookie: string;
    group: string;
    description: string;
    expiration: string;
}

const USED_COOKIES: IUsedCookie[] = [
    {
        cookie: "mtm_consent",
        group: i18n.t("cookies.storages.persistantCookie"),
        description: i18n.t("cookies.mtm_consent.description"),
        expiration: i18n.t("cookies.mtm_consent.expiration"),
    },
    {
        cookie: "mtm_consent_removed",
        group: i18n.t("cookies.storages.persistantCookie"),
        description: i18n.t("cookies.mtm_consent_removed.description"),
        expiration: i18n.t("cookies.mtm_consent_removed.expiration"),
    },
    {
        cookie: "persist:root",
        group: i18n.t("cookies.storages.localStorage"),
        description: i18n.t("cookies.persist:root.description"),
        expiration: i18n.t("cookies.persist:root.expiration"),
    },
    {
        cookie: "_pk_id",
        group: i18n.t("cookies.storages.persistantCookie"),
        description: i18n.t("cookies._pk_id.description"),
        expiration: i18n.t("cookies._pk_id.expiration"),
    },
    {
        cookie: "_pk_ref",
        group: i18n.t("cookies.storages.persistantCookie"),
        description: i18n.t("cookies._pk_ref.description"),
        expiration: i18n.t("cookies._pk_ref.expiration"),
    },
    {
        cookie: "_pk_ses",
        group: i18n.t("cookies.storages.persistantCookie"),
        description: i18n.t("cookies._pk_ses.description"),
        expiration: i18n.t("cookies._pk_ses.expiration"),
    },
    {
        cookie: "_pk_cvar",
        group: i18n.t("cookies.storages.persistantCookie"),
        description: i18n.t("cookies._pk_cvar.description"),
        expiration: i18n.t("cookies._pk_cvar.expiration"),
    },
    {
        cookie: "_pk_hsr",
        group: i18n.t("cookies.storages.sessionCookie"),
        description: i18n.t("cookies._pk_hsr.description"),
        expiration: i18n.t("cookies._pk_hsr.expiration"),
    },
    {
        cookie: "matomo_sessid",
        group: i18n.t("cookies.storages.persistantCookie"),
        description: i18n.t("cookies.matomo_sessid.description"),
        expiration: i18n.t("cookies.matomo_sessid.expiration"),
    },
];

export default USED_COOKIES;
